export const organizeList = (state) => {
  return state.organizeList
}
export const subjectList = (state) => {
  return state.subjectList
}
export const userList = (state) => {
  return state.userList
}
